// C-13 / C-13a / C-13b / S-05 copy (UserFlows C-13, C-13a, S-05; API.md §1.6 for the error messages, per the task
// file's spec-gap notes). UserFlows owns the copy; the confirm dialogs' titles are task 12's own (see the report).
import type { ClinicRole, UserStatus } from '@pa/api/clinic'

export const USERS_PURPOSE = 'Who on your team can see bookings, send links and change settings.'

export const ROLE_LABEL: Record<ClinicRole, string> = { admin: 'Admin', user: 'User' }
export const ROLE_DESCRIPTION: Record<ClinicRole, string> = {
  admin: 'Full access, manages users',
  user: 'Everything except managing users',
}
export const STATUS_LABEL: Record<UserStatus, string> = {
  active: 'Active',
  must_set_password: 'Must set password',
}

/** API.md §1.6 conflict reasons → copy. `self_not_allowed` has one message per action. */
export const USERS_ERRORS = {
  last_admin: 'The clinic needs at least one Admin.',
  self_change_role: "You can't change your own role.",
  self_remove: "You can't remove yourself.",
  self_reset_password: 'Use Forgot password to change your own password.',
  shared_account: 'This person also uses another clinic. Ask support to reset their password.',
  already_member: 'Already on your team',
  account_not_addable: "This email belongs to an account that can't be added here",
  not_found: 'This user no longer exists.',
} as const

/** C-13a field messages (the S-03 wording for the shared issue codes). */
export const ADD_USER_FIELD_MESSAGES: Record<string, string> = {
  required: 'Required.',
  name_length: 'Enter a name (up to 120 characters).',
  email_invalid: 'Enter a valid email address.',
}

export const addUserFieldMessage = (code: string): string => ADD_USER_FIELD_MESSAGES[code] ?? 'Check this field.'

/** D-41: an email that already has an account at another clinic gets no temporary password (UserFlows C-13a). */
export const EXISTING_ACCOUNT_COPY = 'They can sign in with their existing password'

/** The confirm dialogs (UserFlows C-13 gives only "Confirm"; titles are task 12's, bodies UserFlows' effects). */
export const CONFIRM_COPY = {
  reset: {
    title: (name: string) => `Reset ${name}'s password?`,
    body: "They get a new temporary password, shown once. Their sessions end, and they'll set a new password when they next sign in.",
    action: 'Reset password',
  },
  role: {
    title: (name: string, role: ClinicRole) => `Make ${name} ${role === 'admin' ? 'an Admin' : 'a User'}?`,
    body: (role: ClinicRole) => `${ROLE_LABEL[role]}: ${ROLE_DESCRIPTION[role]}.`,
    action: 'Change role',
  },
  remove: {
    title: (name: string) => `Remove ${name}?`,
    body: 'They lose access immediately, and their active sessions end.',
    action: 'Remove',
  },
} as const
